import { computed } from 'vue';
import { useArtifactsStore } from '../store/useArtifactsStore';
import { TrackEvents, useViewerTrack } from './useViewerTrack';

/**
 * Shared composable for OCR text selection and copy actions.
 * Used by both ContentOwnerTopBar (owner) and GuestTopBar (guest).
 */
export const useOcrActions = () => {
  const artifactsStore = useArtifactsStore();
  const { trackItemOwner } = useViewerTrack();

  const isOcrAvailable = computed(() => artifactsStore.isOcrDone && artifactsStore.hasOcrData);
  const isOcrProcessing = computed(() => artifactsStore.isOcrProcessing);
  const isOcrDone = computed(() => artifactsStore.isOcrDone);
  const isSelectionMode = computed(() => artifactsStore.selectionMode);
  const selectedCount = computed(() => artifactsStore.selectedCount);
  const hasSelection = computed(() => artifactsStore.hasSelection);

  const enterSelectionMode = () => {
    artifactsStore.enterSelectionMode();
  };

  const exitSelectionMode = () => {
    artifactsStore.exitSelectionMode();
  };

  const copyAllText = () => {
    artifactsStore.copyAllText();
    trackItemOwner(TrackEvents.VIEWER_OCR_TEXT_COPIED, {
      copy_type: 'all',
      line_count: artifactsStore.ocrLines.length,
    });
  };

  const copySelectedText = () => {
    const lineCount = artifactsStore.selectedCount;
    artifactsStore.copySelectedText();
    trackItemOwner(TrackEvents.VIEWER_OCR_TEXT_COPIED, {
      copy_type: 'selected',
      line_count: lineCount,
    });
  };

  return {
    isOcrAvailable,
    isOcrProcessing,
    isOcrDone,
    isSelectionMode,
    selectedCount,
    hasSelection,
    enterSelectionMode,
    exitSelectionMode,
    copyAllText,
    copySelectedText,
  };
};
